import { useInView } from "../../hooks/useInView";

/**
 * Wraps children in a fade-up reveal animation triggered by scroll.
 * @param {number} delay - animation delay in seconds
 */
export default function Reveal({ children, delay = 0, style = {} }) {
  const [ref, visible] = useInView();

  return (
    <div
      ref={ref}
      style={{
        opacity:    visible ? 1 : 0,
        transform:  visible ? "translateY(0)" : "translateY(26px)",
        transition: `opacity .6s ${delay}s ease, transform .6s ${delay}s ease`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
